// 민감 정보 패턴 (토큰, 비밀번호 포함 로그 필터링)
const SENSITIVE_PATTERNS = [
  /bearer\s+[a-z0-9\-._~+/]+=*/i,
  /authorization:\s*\S+/i,
  /password["\s:=]+\S+/i,
  /token["\s:=]+[a-z0-9\-._~+/]{20,}/i,
  /secret["\s:=]+\S+/i,
];

function containsSensitiveInfo(message: string): boolean {
  return SENSITIVE_PATTERNS.some((pattern) => pattern.test(message));
}

export interface ConsoleEntry {
  level: 'error' | 'warn' | 'log';
  message: string;
  timestamp: string;
  stack?: string;
}

let buffer: ConsoleEntry[] = [];
let maxSize = 50;
let initialized = false;

const originalConsole = {
  error: console.error.bind(console),
  warn: console.warn.bind(console),
  log: console.log.bind(console),
};

function formatArgs(args: unknown[]): string {
  return args
    .map((arg) => {
      if (typeof arg === 'string') return arg;
      if (arg instanceof Error) return arg.message;
      try {
        return JSON.stringify(arg);
      } catch {
        return String(arg);
      }
    })
    .join(' ');
}

function pushEntry(entry: ConsoleEntry): void {
  if (buffer.length >= maxSize) {
    buffer.shift();
  }
  buffer.push(entry);
}

function intercept(level: 'error' | 'warn' | 'log', args: unknown[]): void {
  const message = formatArgs(args);
  if (containsSensitiveInfo(message)) return;

  const entry: ConsoleEntry = {
    level,
    message,
    timestamp: new Date().toISOString(),
  };

  // Error 객체의 stack trace 캡처
  const errorArg = args.find((a) => a instanceof Error) as Error | undefined;
  if (errorArg?.stack) {
    entry.stack = errorArg.stack;
  }

  pushEntry(entry);
}

export function initConsoleCollector(maxEntries = 50): void {
  if (initialized) return;
  maxSize = maxEntries;
  initialized = true;

  console.error = (...args: unknown[]) => {
    intercept('error', args);
    originalConsole.error(...args);
  };

  console.warn = (...args: unknown[]) => {
    intercept('warn', args);
    originalConsole.warn(...args);
  };

  console.log = (...args: unknown[]) => {
    intercept('log', args);
    originalConsole.log(...args);
  };
}

export function getRecentConsoleLogs(): ConsoleEntry[] {
  return [...buffer];
}

export function clearConsoleLogs(): void {
  buffer = [];
}
